import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ParentDataService } from '../../service/parent-data.service';
import { NavbarService } from '../navbar.service';
import { LocalStorageService } from "ng2-webstorage";
import {AppConstants} from '../../../app.constants';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  public children: any;
  public loading: boolean = true;
  public showMenu = false;
  public selectedChild: any;
  public selectedChildId: any;
  public spinnershow: boolean = false;
  public image: string = "";
  public parent_email: string = "";


  public schoolid: any;
  public attachment;


  isStudentDetailsExpanded: boolean = false;
  isManageUserExpanded: boolean = false;
  isTeacherDetailsExpanded: boolean = false;
  isQuantaIntelligenceExpanded: boolean = false;
  isPaperBankExpanded: boolean = false;
  isIngestDataExpanded: boolean = false;


  public imgUrl: string;
  public schoolLogo: string;



  toggleSubtopics(section: string) {


    if (section === 'student_details') {
      if (this.isStudentDetailsExpanded == false){
        this.isStudentDetailsExpanded = true;
        this.isManageUserExpanded = false;
        this.isTeacherDetailsExpanded = false;
        this.isQuantaIntelligenceExpanded = false;
      }else {
        this.isStudentDetailsExpanded = false;
      }
    }
    else if (section === 'manage_user') {
      if (this.isManageUserExpanded == false){
        this.isManageUserExpanded = true;
        this.isTeacherDetailsExpanded = false;
        this.isStudentDetailsExpanded = false;
        this.isQuantaIntelligenceExpanded = false;
      }else {
        this.isManageUserExpanded = false;
      }
    }
    else if (section === 'teacher_details') {
      if (this.isTeacherDetailsExpanded == false){
        this.isTeacherDetailsExpanded = true;
        this.isManageUserExpanded = false;
        this.isStudentDetailsExpanded = false;
        this.isQuantaIntelligenceExpanded = false;
      }else {
        this.isTeacherDetailsExpanded = false;
      }
    }
    else if (section === 'quanta_intelligence') {
      if (this.isQuantaIntelligenceExpanded == false){
        this.isQuantaIntelligenceExpanded = true;
        this.isTeacherDetailsExpanded = false;
        this.isManageUserExpanded = false;
        this.isStudentDetailsExpanded = false;
      }else {
        this.isQuantaIntelligenceExpanded = false;
      }
    }
    else {
      this.isStudentDetailsExpanded = false;
      this.isManageUserExpanded = false;
      this.isTeacherDetailsExpanded = false;
      this.isQuantaIntelligenceExpanded = false;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }



  paperBank(section: string) {
    if (this.isPaperBankExpanded) {
      this.isPaperBankExpanded = false;
    }else{
      this.isPaperBankExpanded = true;
    }
    console.log(this.isPaperBankExpanded);
  }


  ingestData(section: string) {
    if (this.isIngestDataExpanded) {
      this.isIngestDataExpanded = false;
    }else{
      this.isIngestDataExpanded = true;
    }
    console.log(this.isIngestDataExpanded);
  }




    constructor(public router: Router,
                public navbarService: NavbarService,
                private _parentData: ParentDataService,
                private route: ActivatedRoute,
                private localStorage: LocalStorageService,
                private appConstants: AppConstants,) { }


  ngOnInit() {

        this.schoolid = this.localStorage.retrieve('schoolid');

        this.schoolLogo = this.localStorage.retrieve("logo");
        this.imgUrl = this.appConstants.fileDownloadUrl;

    console.log(this.attachment);
    console.log(this.schoolid);


      this.loading = false;

  }

  navigateToChild(child_id){
    console.log("navigateToChild", child_id);
    this.localStorage.store("CurrentChildId", child_id);
    this.selectedChildId = child_id;
    this.selectedChild = this.children.find(data => {
      return data.ChildId == child_id
    });
    this.localStorage.store("CurrentChild", this.selectedChild);
    this.localStorage.store('schoolId', this.selectedChild["Schoolid"]);
    this.router.navigate([`parent/${child_id}`]);

  }

  menu() {
    this.showMenu = !this.showMenu
  }
  outsideClick() {
    this.showMenu = false
  }
  selectChild() {
    this.showMenu = false
  }
  onImgError(event) {
    event.target.src = this.image;
  }

  navigateToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  toggleSidebar() {
    this.navbarService.toggleSideNav = !this.navbarService.toggleSideNav;
  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/sidebar/sidebar.component.ts